<template>
  <v-container>
    <v-card>
      <v-card-title>
        ユーザ情報の登録
      </v-card-title>
      <v-card-subtitle>
        ログインユーザの情報を設定します。
        この情報は確認表の実施者情報と連動します。
      </v-card-subtitle>
      <v-divider />
      <v-card-text>
        <v-row dense>
          <v-col cols="3">
            <h4>登録情報</h4>
          </v-col>
          <v-col cols="9">
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  v-model="form.name"
                  outlined
                  label="氏名"
                  :error-messages="validationError.name"
                  dense />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="8">
                <v-text-field
                  v-model="form.company_name"
                  outlined
                  label="所属団体"
                  :error-messages="validationError.company_name"
                  dense />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="4">
                <v-text-field
                  v-model="form.mobilephone"
                  outlined
                  label="携帯番号"
                  :error-messages="validationError.mobilephone"
                  dense />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="form.telephone"
                  outlined
                  label="TEL"
                  :error-messages="validationError.telephone"
                  dense />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="mt-2 mb-5" />
        <v-row dense>
          <v-col cols="3">
            <h4>ログイン情報</h4>
          </v-col>
          <v-col cols="9">
            <v-row dense>
              <v-col cols="6">
                <v-text-field
                  v-model="form.login_id"
                  outlined
                  label="ログインID"
                  :error-messages="validationError.login_id"
                  dense />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="8">
                <v-text-field
                  v-model="form.email"
                  outlined
                  label="メールアドレス"
                  :error-messages="validationError.email"
                  dense />
              </v-col>
            </v-row>
            <v-row dense>
              <v-checkbox
                v-if="!isNew"
                v-model="form.change_password"
                label="パスワードを変更する" />
            </v-row>
            <v-row
              v-if="isNew || form.change_password"
              dense>
              <v-col cols="6">
                <v-text-field
                  v-model="form.password"
                  outlined
                  dense
                  :error-messages="validationError.password"
                  label="パスワード" />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="form.password_confirmation"
                  outlined
                  dense
                  :error-messages="validationError.password_confirmation"
                  label="パスワード(確認)" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="mt-2 mb-5" />
        <v-row
          dense>
          <v-col cols="3">
            <h4>権限</h4>
          </v-col>
          <v-col cols="9">
            <v-row
              v-if="$store.state.auth.permission === 2"
              dense>
              <v-col cols="5">
                <block-select
                  v-model="form.block_id">
                </block-select>
              </v-col>
            </v-row>
            <v-row
              v-if="$store.state.auth.permission === 2"
              dense>
              <v-col cols="5">
                <permission-select
                  v-model="form.permission">
                </permission-select>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="5">
                <v-checkbox
                  v-model="form.has_approval_authority"
                  label="協会審査員としての承認権限"
                  :true-value="1"
                  :false-value="0" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="mt-2 mb-5" />
        <v-row dense>
          <v-col cols="3">
            <h4>(NADA登録)石綿調査診断士登録証</h4>
          </v-col>
          <v-col cols="9">
            <license-text-fields
              v-model="form.license1"
              :error="validationError.license1" />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="3">
            <h4>特定建築物石綿含有建材調査者修了証</h4>
          </v-col>
          <v-col cols="9">
            <license-text-fields
              v-model="form.license2"
              :error="validationError.license2" />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="3">
            <h4>一般建築物石綿含有建材調査者修了証</h4>
          </v-col>
          <v-col cols="9">
            <license-text-fields
              v-model="form.license3"
              :error="validationError.license3" />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="3">
            <h4>一戸建て等石綿含有建材調査者修了証</h4>
          </v-col>
          <v-col cols="9">
            <license-text-fields
              v-model="form.license4"
              :error="validationError.license4" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <global-footer>
      <template #left>
        <v-btn
          @click.prevent="onCancelClicked">
          キャンセル
        </v-btn>
      </template>
      <template #right>
        <v-btn
          class="mr-3"
          color="error"
          @click.prevent="onDeleteClicked">
          削除
        </v-btn>
        <v-btn
          color="primary"
          @click.prevent="onSaveClicked">
          保存
        </v-btn>
      </template>
    </global-footer>

    <confirm-dialog
      :value="deletionConfirmDialog"
      title="削除確認"
      ok-text="削除する"
      cancel-text="キャンセル"
      @ok="onDeletionExecuteClicked"
      @cancel="deletionConfirmDialog = false"
      @input="deletionConfirmDialog = false">
      <v-card-text>
        このデータを削除します。<br />この操作は元に戻せません。
      </v-card-text>
    </confirm-dialog>
  </v-container>
</template>

<script>

import PermissionSelect from '../PermissionSelect'
import BlockSelect from '../BlockSelect'
import LicenseTextFields from './LicenseTextFields'
import ConfirmDialog from '../ConfirmDialog'

export default {
  name: 'UserForm',
  components: {
    LicenseTextFields,
    BlockSelect,
    PermissionSelect,
    ConfirmDialog,
  },
  props: {
    id: {
      type: [String, Number],
      default: 1,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        mobilephone: '',
        telephone: '',
        fax: '',
        company_name: '',
        password: '',
        password_confirmation: '',
        permission: 0,
        block_id: 3,
        license1: {
          code: '',
          registration_date: '',
          expiration_date: '',
        },
        license2: {
          code: '',
          registration_date: '',
          expiration_date: '',
        },
        license3: {
          code: '',
          registration_date: '',
          expiration_date: '',
        },
        license4: {
          code: '',
          registration_date: '',
          expiration_date: '',
        },
        has_approval_authority: 0,
      },
      deletionConfirmDialog: false,
      validationError: {},
    }
  },
  mounted() {
    if (!this.isNew) {
      this.fetchItem()
    }
  },
  methods: {
    async fetchItem() {
      const { data } = await window.axios.get(`/api/users/${this.id}`)
      this.form = data
      const licenseDefault = {
        code: '',
        registration_date: '',
        expiration_date: '',
      }
      this.form.license1 = this.form.license1 ?? { ...licenseDefault }
      this.form.license2 = this.form.license2 ?? { ...licenseDefault }
      this.form.license3 = this.form.license3 ?? { ...licenseDefault }
      this.form.license4 = this.form.license4 ?? { ...licenseDefault }
    },
    onCancelClicked() {
      this.$router.go(-1)
    },
    async onSaveClicked() {
      try {
        // ブロック管理者は自ブロック所属ユーザとなる
        if (this.$store.state.auth.permission === 1) {
          this.form.block_id = this.$store.state.auth.block_id
        }

        if (this.isNew) {
          await window.axios.post('/api/users', this.form)
        } else {
          await window.axios.put(`/api/users/${this.id}`, this.form)
        }
        this.$router.push({ name: 'userIndex' })
      } catch ({ response }) {
        this.$store.commit('decrementLoadingCount')
        if (response.status === 422) {
          this.validationError = response.data.errors
        }
      }
    },
    async onDeletionExecuteClicked() {
      try {
        await window.axios.delete(`/api/users/${this.id}`)

        this.deletionConfirmDialog = false
        this.$router.push({
          name: 'userIndex',
        })
      } catch ({ response }) {
        this.$store.commit('decrementLoadingCount')
        this.deletionConfirmDialog = false

        if (response.status === 422) {
          this.validationError = response.data.errors
        }
      }
    },
    onDeleteClicked() {
      this.deletionConfirmDialog = true
    },
  },
}
</script>
